import { selfInstantiateOnLoad } from "../utilities/pageUtilities";
export default class AddressAutofill {
    constructor() {
        this._autofillFields = new Map();
        this.setupFields = () => {
            const fields = document.querySelectorAll("[data-dlron-type='zipcode'], [name='Zip']");
            if (fields.length === 0) {
                return;
            }
            const autofillFields = [];
            for (const field of fields) {
                const form = field.closest("form");
                const cityField = form.querySelector("[name='City'], [data-dlron-type='city']");
                const stateField = form.querySelector("[name='State'], [data-dlron-type='state']");
                if (cityField || stateField) {
                    this._autofillFields.set(field, {
                        city: cityField,
                        state: stateField,
                    });
                    field.addEventListener("blur", () => this.tryGetCityAndState(field));
                }
            }
        };
        this.tryGetCityAndState = async (zip) => {
            const value = zip.value;
            if (!/^\d{5}$/.test(value)) {
                return;
            }
            try {
                const data = await fetch(`/api/oemssaa/subarumexico/address-autofill/${value}`).then((res) => res.json());
                if (data.notFound || data.error) {
                    console.warn(data.error ??
                        "Undocumented failure reason from OEMSSAA -> SubaruMexicoRepository");
                    return;
                }
                this.populateFields(zip, data);
            }
            catch (err) {
                console.warn(err.message, err);
            }
        };
        this.populateFields = (zip, res) => {
            const fields = this._autofillFields.get(zip);
            if (!fields) {
                console.warn("Tried to run autofill on a zipcode field that was not found in stored field map.");
                return;
            }
            if (fields.city && res.city) {
                fields.city.value = res.city;
            }
            if (fields.state && res.state) {
                fields.state.value = res.state;
            }
        };
        this.setupFields();
    }
}
selfInstantiateOnLoad(AddressAutofill);
